<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div class="content_down">
          <div class="content_head">
            <div class="content_head_ico">
              <img src="../../../assets/images/estorage/content_title_ico_blue.png" alt=""/>
            </div>
            <div class="content_head_title" v-show="redactState===0">
              新增货位卡
            </div>
            <div class="content_head_title" v-show="redactState===1">
              货位卡详情
            </div>
            <div class="content_head_title" v-show="redactState===2">
              编辑货位卡
            </div>
            <div class="content_head_button">
              <lk-button img="save.png" @click="saveButton()" v-show="redactState!==1" style="margin-right: 20px">保存
              </lk-button>
              <lk-button img="back.png" @click="goBack" type="lk_button_blue">返回</lk-button>
            </div>
          </div>
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检编号</span>
              </div>
              <el-input v-model="dataSet.str1" placeholder="请输入内容" :disabled="redactState!==0"
                        maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检单号</span>
              </div>
              <el-input v-model="dataSet.str2" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
<!--            <div class="content_element_only">-->
<!--              <div class="content_element_only_title">-->
<!--                <span>库点</span>-->
<!--              </div>-->
<!--              <el-input v-model="dataSet.str3" placeholder="请输入内容" maxlength="15"></el-input>-->
<!--            </div>-->
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>仓房</span>
              </div>
              <el-input v-model="dataSet.str4" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>仓房类型</span>
              </div>
              <el-select v-model="dataSet.str5" filterable placeholder="请选择">
                <el-option
                    v-for="item in grainNatureList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>总仓容(kg)</span>
              </div>
              <el-input v-model="dataSet.str4" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>当前仓容(kg)</span>
              </div>
              <el-input v-model="dataSet.str4" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食权属</span>
              </div>
              <el-select v-model="dataSet.str6" placeholder="请选择">
                <el-option
                    v-for="item in foodRightsOwnershipList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="content_element">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检类型</span>
              </div>
              <el-select v-model="dataSet.str7" placeholder="请选择">
                <el-option
                    v-for="item in foodRightsOwnershipList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食品种</span>
              </div>
              <el-select v-model="dataSet.str8" placeholder="请选择">
                <el-option
                    v-for="item in grainKindList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食等级</span>
              </div>
              <el-select v-model="dataSet.str9" placeholder="请选择">
                <el-option
                    v-for="item in grainLevelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>粮食产地</span>
              </div>
              <el-cascader
                  v-model="selectedOptions"
                  :options="options"
                  filterable
                  @change="addChange">
              </el-cascader>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>数量</span>
              </div>
              <el-input v-model="deliverCompany" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检人</span>
              </div>
              <el-input v-model="deliverCompany" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检时间</span>
              </div>
              <el-input v-model="deliverCompany" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检结果</span>
              </div>
              <el-input v-model="deliverCompany" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
            <div class="content_element_only_remark">
              <div class="content_element_only_title">
                <span>备注</span>
              </div>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
            </div>
          </div>
          <div class="content_element" style="border-bottom: 0">
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>质检模板</span>
              </div>
              <el-input v-model="dataSet.str1" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
            <div class="content_element_only">
              <div class="content_element_only_title">
                <span>检验标准</span>
              </div>
              <el-input v-model="dataSet.str2" placeholder="请输入内容" maxlength="15"></el-input>
            </div>
          </div>
          <div class="Notice_alert">
            <el-table border :data="alertNotice" style="width: 100%">
              <el-table-column prop="1" label="质检项" align="center"></el-table-column>
              <el-table-column prop="2" label="检测值" align="center"></el-table-column>
              <el-table-column prop="3" label="判断标准" align="center"></el-table-column>
              <el-table-column prop="4" label="结果" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
        <!--        保存提示-->
        <el-dialog title="提示" :visible.sync="alertShow" width="30%" style="margin-top: 20vh">
          <span>是否确认保存</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="alertShow = false">取消</el-button>
            <el-button type="primary" @click="alertShow = false">确认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {CodeToText, regionData} from 'element-china-area-data'
export default {
  name: 'BarncardAdd',
  data() {
    return {
      dataSet: {
        str1: '',
        str2: '',
        str3: '',
        str4: '',
        str5: '',
        str6: '',
        str7: '',
        str8: '',
        str9: '',
        str10: '',
        str11: '',
        str12: '',
        str13: '',
        str14: '',
        str15: '',
        str16: '',
        str17: '',
        str18: '',
        str19: '',
        str20: ''
      },
      alertNotice: [
        {
          1: "水分%",
          2: "",
          3: "",
          4: ""
        },
        {
          str1: "杂质%",
          str2: "",
          str3: "",
          str4: ""
        },
      ],
      foodRightsOwnershipList: [
        {
          value: '浙粮集团',
          label: '浙粮集团'
        },
        {
          value: '镇海粮库',
          label: '镇海粮库'
        },
        {
          value: '浙江省粮食与物资储备局',
          label: '浙江省粮食与物资储备局'
        }
      ],
      deliverCompany: '',
      grainKindList: (function () {
        let arr = [];
        let list = ['小麦', '晚籼稻', '晚粳稻', 'Y两优', '菜籽油', '晚籼米'];
        for (let i = 0; i < list.length; i++) {
          arr.push({
            'value': list[i],
            'label': list[i]
          })
        }
        return arr;
      })(),
      grainLevelList: (function () {
        let arr = [];
        let list = ['国标一等', '国标二等', '国标三等', '国标五等', '等外', '一级', '二级', '三级', '四级'];
        for (let i = 0; i < list.length; i++) {
          arr.push({
            'value': list[i],
            'label': list[i]
          })
        }
        return arr;
      })(),
      grainNatureList: [
        {
          value: '储备粮'
        }, {
          value: '商品粮'
        }
      ],
      options: regionData,
      selectedOptions: [],
      grainArea: '',
      alertShow: false,
      ids: '',
      redactState: 0
    }
  },
  methods: {
    goBack() {
      this.$emit('update:comName', 'BarncardNew')
    },
    // 保存
    saveButton(val) {
      console.log(val)
      this.$confirm('是否确认保存这条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消保存'
        })
      })
    },
    // 将区域码转换成汉字
    addChange(val) {
      console.log(regionData)
      console.log(CodeToText[val[0]] + '/' + CodeToText[val[1]] + '/' + CodeToText[val[2]])
      // this.dataSet.str10 = CodeToText[val[0]] + CodeToText[val[1]] + CodeToText[val[2]]
    },
  },
  mounted() {
    if (this.$store.state.Quality.qualityState) {
      this.redactState = Number(this.$store.state.Quality.qualityState)
    }
    if (this.$store.state.Quality.qualityId) {
      this.ids = this.$store.state.Quality.qualityId
    }
  }
}
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0
  }

  .content_head_button {
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;

      ::v-deep .el-select {
        width: 100%;
      }

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .input-with-select {
        .el-select {
          width: 65px;
        }

        ::v-deep .el-input__inner {
          text-transform: uppercase;
        }
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.content_element {
  margin-top: 50px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEBEB;
  text-align: right;
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .content_element_only {
    width: 33.3333%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 100px;
      margin-right: 15px;
      font-size: 14px;

      .significance {
        color: red;
      }
    }

    ::v-deep .el-select {
      width: 50%;

      .el-input {
        width: 100%;
      }
    }

    ::v-deep .el-cascader {
      width: 50%;

      .el-input {
        width: 100%;
      }
    }

    /*样式穿透*/
    ::v-deep .el-input {
      //width:12.5vw;
      width: 50%;
      background: #F4F7FD;
    }

    ::v-deep .el-input__inner {
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input__icon {
      line-height: 36px;
    }
  }

  .content_element_only_remark {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 38px;

    .content_element_only_title {
      width: 100px;
      margin-right: 15px;
      font-size: 14px;

      .significance {
        color: red;
      }
    }

    ::v-deep.el-textarea {
      width: 83.333%;
    }
  }
}

.Notice_alert {
  font-size: 14px;
  color: #969696;

  ::v-deep .el-table {
    -webkit-text-size-adjust: none;
    font-size: 14px;
  }

  ::v-deep .el-table th {
    background-color: #f4f7fd;
    color: #2A2A2A;
  }

  ::v-deep .el-table .el-table__cell {
    padding: 30px 0;
  }

  ::v-deep .el-table thead {
    color: #969696;
    -webkit-text-size-adjust: none;
    font-size: 14px;
  }
}
</style>
